<template>
  <div class="modal-wrap" v-if="visible">
    <div class="modal-cover"></div>
    <div class="modal-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    appendBody: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    if (this.appendBody) {
      this.$nextTick(() => {
        const body = document.querySelector("body");
        if (body.append) {
          body.append(this.$el);
        } else {
          body.appendChild(this.$el);
        }
      });
    }
  }
}
</script>

<style lang="less" scoped>
.modal-wrap {
  position: fixed;
  width: 100%;
  height: 100%;
  z-index: 9999;
  left: 0;
  top: 0;

  .modal-cover {
    width: 100%;
    height: 100%;
    background: rgba(0,0,0,0.6000);
    position: absolute;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
  }

  .modal-content {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
  }
}
</style>